import * as Types from "../../../../../generated/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type JobsStatesQueryVariables = Types.Exact<{
  limit: Types.Scalars["Float"];
  offset: Types.Scalars["Float"];
  query: Types.Scalars["String"];
}>;

export type JobsStatesQuery = {
  __typename?: "Query";
  jobsStates: {
    __typename?: "EntitiesWithCountForSelect";
    count: number;
    entities: Array<{ __typename?: "Entity"; id: string; name: string }>;
  };
};

export const JobsStatesDocument = gql`
  query JobsStates($limit: Float!, $offset: Float!, $query: String!) {
    jobsStates(limit: $limit, offset: $offset, query: $query) {
      entities {
        id
        name
      }
      count
    }
  }
`;

/**
 * __useJobsStatesQuery__
 *
 * To run a query within a React component, call `useJobsStatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobsStatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobsStatesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useJobsStatesQuery(
  baseOptions: Apollo.QueryHookOptions<
    JobsStatesQuery,
    JobsStatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<JobsStatesQuery, JobsStatesQueryVariables>(
    JobsStatesDocument,
    options
  );
}
export function useJobsStatesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    JobsStatesQuery,
    JobsStatesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<JobsStatesQuery, JobsStatesQueryVariables>(
    JobsStatesDocument,
    options
  );
}
export type JobsStatesQueryHookResult = ReturnType<typeof useJobsStatesQuery>;
export type JobsStatesLazyQueryHookResult = ReturnType<
  typeof useJobsStatesLazyQuery
>;
export type JobsStatesQueryResult = Apollo.QueryResult<
  JobsStatesQuery,
  JobsStatesQueryVariables
>;
